import { ValueLists } from './ValueListsEnums';

export enum AppConsts {
  AccessToken = 'access_token'
}

export enum Role {
  Admin = 'Admin'
}

export const INVOICE_STATUS_CONFIRMED = 'Confirmed';

export const DATE_TIME_FORMATS = {
  DATE_AND_TIME: 'DD/MM/YYYY  HH:mm',
  DATE: 'DD/MM/YYYY',
  DATE_AND_TIME_AM_PM: 'DD/MM/YYYY hh:mm A'
};

type valueListOptions = {
  [key: string]: string;
};

export const ValueListNames: valueListOptions = {
  [ValueLists.CompanyType]: 'CompanyTypes',
  [ValueLists.MarketActivity]: 'MarketActivities',
  [ValueLists.MembershipType]: 'MembershipTypes',
  [ValueLists.ProductCode]: 'ProductCodes',
  [ValueLists.TitleInternal]: 'TitlesInternal'
};
